import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
import payment from '@/api/modules/payment/payment'
import productModel from '@/api/modules/product/product'
Vue.use(Resource)

export default {
	getById (id) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/payments/' + id + '?expand=company,manager,product', {}).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	},
	getProductTypeByPaymentId (paymentId) {
		return new Promise((resolve, reject) => {
			payment.getById(paymentId).then((result) => {
				const productId = result.body.data.product_id
				productModel.getProductById(productId).then((product) => {
					productModel.getProductTypeParent(product.type_id).then((productType) => {
						resolve(productType[0].system_name)
					})
				})
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/models/payment/payment.js